import React from 'react';

const MAX_RETRIES = 5;
const RETRY_DELAY = 3000;

class RetryableErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      retryKey: 0,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows fallback (or nothing)
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Lazy-load error caught:', error);

    // Automatically retry after a delay
    setTimeout(() => {
      this.setState((prev) => ({
        hasError: !(prev.retryKey < MAX_RETRIES),
        retryKey: Math.min(prev.retryKey + 1, MAX_RETRIES), // force remount of child
      }));
    }, this.props.retryDelay || RETRY_DELAY); // default 3s
  }

  render() {
    if (this.state.hasError) {
      // You could show a loader, fallback UI, or null
      return null;
    }

    // Attach retryKey to force remount on retry
    return (
      <React.Fragment key={this.state.retryKey}>
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default RetryableErrorBoundary;
